import { ElLink } from 'element-plus/es';
import 'element-plus/es/components/link/style/css';
export default {
  name: "BoardTitle",
  components: {
    ElLink
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    more: {
      type: String,
      default: ''
    }
  }
};